import React from 'react';

interface MetronomeProps {
  /** Pixel size of the SVG. Defaults to 24. */
  size?: number;
  /** Optional className passed through (e.g. for color + alignment). */
  className?: string;
  /** Accessible label. Pass empty string to mark decorative. */
  title?: string;
}

// Metronome mark — the canonical Cadence icon. Theme-aware: the body
// renders with `currentColor` so it picks up the surrounding text
// colour (slate on light surfaces, near-white on dark). The pendulum
// stays amber #C97A2B in both modes — it's the brand accent.
//
// Source: shared-docs/redesign/favicon.svg, with the body fill swapped
// from the literal #1D2939 to currentColor.
export function Metronome({ size = 24, className, title = 'Cadence' }: MetronomeProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 64 64"
      role={title ? 'img' : undefined}
      aria-label={title || undefined}
      aria-hidden={title ? undefined : true}
      className={className}
    >
      {title ? <title>{title}</title> : null}
      <defs>
        <mask id="cad-metronome-slot">
          <rect width="64" height="64" fill="white" />
          <rect x="29.5" y="18" width="5" height="29" rx="2.5" fill="black" />
        </mask>
      </defs>
      <g>
        <path
          mask="url(#cad-metronome-slot)"
          fill="currentColor"
          d="M 20 13 L 44 13 L 55 49 L 9 49 Z"
        />
        <rect fill="currentColor" x="6" y="49" width="52" height="7" rx="1.5" />
        <g transform="rotate(20 32 47)">
          <rect fill="#C97A2B" x="30" y="4" width="4" height="42" rx="2" />
          <circle fill="#C97A2B" cx="32" cy="5.5" r="4.4" />
        </g>
      </g>
    </svg>
  );
}

export default Metronome;
